export const hasPermission = (name) => {
  const permissionsString = localStorage.getItem("permissions");
  if (!permissionsString) {
    return false;
  }
  const permissions = JSON.parse(permissionsString);

  return !!permissions.includes(name);
};
